export default __webpack_public_path__ + "static/media/FacebookSansRegular.2d54b29a.woff";